import { useLocalStorage } from './useLocalStorage';
export var useViewAs = function () {
    var initialViewAsData = {
        id: '',
        careProviderId: '',
        name: '',
        timeZone: '',
    };
    var _a = useLocalStorage('view_as_data', initialViewAsData, true, {
        isStringify: true,
        storageType: window.sessionStorage,
    }), viewAsData = _a[0], setViewAsData = _a[1];
    var viewAsEnabled = !!(viewAsData === null || viewAsData === void 0 ? void 0 : viewAsData.careProviderId);
    return {
        viewAsEnabled: viewAsEnabled,
        viewAsData: viewAsData,
        setViewAsData: setViewAsData,
        initialViewAsData: initialViewAsData,
    };
};
